import React from 'react'
import { number } from 'prop-types'

function ScalableProduction({ width = 16, height = 24, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.99201 18.6663C3.6265 18.6663 3.30208 18.5491 3.01875 18.3145C2.73541 18.0799 2.56199 17.7836 2.49846
        17.4256L1.34521 10.6478C1.3074 10.4256 1.3611 10.2251 1.50629 10.0463C1.65149 9.86758 1.84357 9.77795 2.08254
        9.77745H13.9175C14.157 9.77745 14.3493 9.86708 14.4945 10.0463C14.6397 10.2256 14.6931 10.4261 14.6548
        10.6478L13.5016 17.4256C13.4386 17.7836 13.2654 18.0799 12.9821 18.3145C12.6987 18.5491 12.374 18.6663 12.008
        18.6663H3.99201ZM6.48757 14.2219H9.51248C9.72674 14.2219 9.90647 14.1508 10.0517 14.0086C10.1969 13.8663 10.2692
        13.6905 10.2687 13.4812C10.2682 13.2718 10.1956 13.096 10.0509 12.9537C9.90622 12.8115 9.72674 12.7404 9.51248
        12.7404H6.48757C6.2733 12.7404 6.09382 12.8115 5.94913 12.9537C5.80444 13.096 5.73184 13.2718 5.73134
        13.4812C5.73083 13.6905 5.80343 13.8666 5.94913 14.0093C6.09483 14.152 6.27431 14.2229 6.48757 14.2219ZM3.46265
        9.03671C3.24839 9.03671 3.06891 8.9656 2.92422 8.82338C2.77953 8.68116 2.70693 8.50535 2.70643 8.29597C2.70592
        8.08659 2.77852 7.91079 2.92422 7.76856C3.06992 7.62634 3.2494 7.55523 3.46265 7.55523H12.5374C12.7517 7.55523
        12.9314 7.62634 13.0766 7.76856C13.2218 7.91079 13.2941 8.08659 13.2936 8.29597C13.2931 8.50535 13.2205 8.6814
        13.0758 8.82412C12.9311 8.96684 12.7517 9.0377 12.5374 9.03671H3.46265ZM4.97511 6.81449C4.76084 6.81449 4.58137
        6.74338 4.43668 6.60116C4.29198 6.45893 4.21939 6.28313 4.21888 6.07375C4.21838 5.86437 4.29098 5.68856 4.43668
        5.54634C4.58238 5.40412 4.76185 5.33301 4.97511 5.33301H11.0249C11.2392 5.33301 11.4189 5.40412 11.5641
        5.54634C11.7093 5.68856 11.7817 5.86437 11.7812 6.07375C11.7807 6.28313 11.7081 6.45918 11.5634 6.6019C11.4187
        6.74461 11.2392 6.81548 11.0249 6.81449H4.97511Z"
        fill="#73ABF5"
      />
    </svg>
  )
}

ScalableProduction.propTypes = {
  width: number,
  height: number,
}

export default ScalableProduction
